module.exports = __webpack_public_path__ + "static/media/web3.80ce1412.png";